import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hr from './locales/hr.json';
import en from './locales/en.json';
import { APP_LANGUAGE, AppLanguage } from './language.config';

const storedLanguage = localStorage.getItem('language');
const initialLanguage: AppLanguage =
	storedLanguage === 'hr' || storedLanguage === 'en'
		? storedLanguage
		: APP_LANGUAGE;

i18n.use(initReactI18next).init({
	resources: {
		hr: { translation: hr },
		en: { translation: en },
	},
	lng: initialLanguage,
	fallbackLng: 'hr',
	interpolation: {
		// react already escapes values
		escapeValue: false,
	},
});

export default i18n;
